import { render, staticRenderFns } from "./OrderED.vue?vue&type=template&id=b140a4e4"
import script from "./OrderED.vue?vue&type=script&lang=js"
export * from "./OrderED.vue?vue&type=script&lang=js"
import style0 from "./OrderED.vue?vue&type=style&index=0&id=b140a4e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports